(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-author-collection"]) return;
  try {
    
  /*
    Plan 2I punch · desktop mouse drag-scroll for horizontal book rows.
    Mobile / touch already scrolls natively; this only wires pointer-type
    mouse and pen. Pointer events let one handler cover both. Click on a
    child after a >5px drag is suppressed so a user dragging the row past
    a book cover doesn't accidentally navigate to that product.
  */
  (function () {
    var scrollers = document.querySelectorAll('[data-jef-drag-scroll]');
    scrollers.forEach(function (el) {
      var isDown = false;
      var captured = false;
      var startX = 0;
      var scrollLeft = 0;
      var dragDistance = 0;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        captured = false;
        dragDistance = 0;
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
        // Do NOT setPointerCapture on press: capturing the row redirects the
        // click off child links and makes the book cards unclickable. Capture
        // only once an actual drag begins (in pointermove, past the threshold).
      });

      el.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var x = e.pageX - el.offsetLeft;
        var walk = (x - startX) * 1.5;
        dragDistance = Math.abs(walk);
        if (!captured && dragDistance > 4) {
          captured = true;
          el.classList.add('jef-drag-scroll--active');
          try { el.setPointerCapture(e.pointerId); } catch (_) {}
        }
        if (captured) {
          e.preventDefault();
          el.scrollLeft = scrollLeft - walk;
        }
      });

      function release(e) {
        if (!isDown) return;
        isDown = false;
        el.classList.remove('jef-drag-scroll--active');
        if (captured) { try { el.releasePointerCapture(e.pointerId); } catch (_) {} }
        captured = false;
      }
      el.addEventListener('pointerup', release);
      el.addEventListener('pointerleave', release);
      el.addEventListener('pointercancel', release);

      el.addEventListener('click', function (e) {
        if (dragDistance > 5) {
          e.preventDefault();
          e.stopPropagation();
        }
        dragDistance = 0;
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-jef-patchen-entry-product"]) return;
  try {
    
  (function () {
    const root = document.currentScript ? document.currentScript.closest('.jef-patchen-entry') : null;
    const forms = document.querySelectorAll('.jef-patchen-entry__form');

    forms.forEach(function (form) {
      const fileInput = form.querySelector('[data-jef-file-input]');
      const linkInput = form.querySelector('[data-jef-link-input]');
      const feedback  = form.querySelector('[data-jef-file-feedback]');
      const submit    = form.querySelector('[data-jef-submit]');

      const MAX_BYTES = 20 * 1024 * 1024;

      function formatSize(bytes) {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
      }

      if (fileInput && feedback) {
        fileInput.addEventListener('change', function () {
          feedback.hidden = true;
          feedback.textContent = '';
          feedback.classList.remove('is-warning');

          const file = fileInput.files && fileInput.files[0];
          if (!file) return;

          const sizeStr = formatSize(file.size);
          if (file.size > MAX_BYTES) {
            feedback.textContent = file.name + ' (' + sizeStr + ') is over the 20 MB upload limit. Clear this field and use the Manuscript link below instead.';
            feedback.classList.add('is-warning');
          } else {
            feedback.textContent = file.name + ' (' + sizeStr + ')';
          }
          feedback.hidden = false;
        });
      }

      form.addEventListener('submit', function (event) {
        const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
        const hasLink = linkInput && linkInput.value && linkInput.value.trim().length > 0;

        if (!hasFile && !hasLink) {
          event.preventDefault();
          if (feedback) {
            feedback.hidden = false;
            feedback.classList.add('is-warning');
            feedback.textContent = 'Attach a manuscript file or paste a link to one before submitting.';
          }
          if (fileInput) fileInput.focus();
          return;
        }

        if (hasFile && fileInput.files[0].size > MAX_BYTES) {
          event.preventDefault();
          if (feedback) {
            feedback.hidden = false;
            feedback.classList.add('is-warning');
            feedback.textContent = 'File is over 20 MB. Remove it and paste a link instead.';
          }
          if (fileInput) fileInput.focus();
          return;
        }

        if (submit) {
          submit.disabled = true;
          submit.dataset.originalText = submit.textContent;
          submit.textContent = 'Submitting...';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
